import React from 'react';
import styles from './Find.module.css';
import { NavLink } from 'react-router-dom';

const Card = ({image, make,link}) => {
  return (
    <div className={styles.card}>
      <img src={image} alt="/" />
      <NavLink to={link}><p> {make}</p></NavLink>
    </div>
  );
}

export default Card;
